import React from 'react';
import '../../../../css/common/chat/ChatHeaderControls.css';

const joinClassNames = (...tokens) => tokens.filter(Boolean).join(' ');

const normalizeBadgeCount = (value) => {
  const count = Number(value);
  if (!Number.isFinite(count)) return 0;
  return Math.max(0, Math.floor(count));
};

const formatBadgeCount = (count) => (count > 99 ? '99+' : String(count));

const ChatHeaderIconButton = ({
  className = '',
  iconClassName = '',
  badgeCount = 0,
  showZeroBadge = false,
  badgeClassName = '',
  type = 'button',
  ...props
}) => {
  const normalizedBadgeCount = normalizeBadgeCount(badgeCount);
  const shouldShowBadge =
    normalizedBadgeCount > 0 || (showZeroBadge && normalizedBadgeCount === 0);

  return (
    <button type={type} className={joinClassNames('chat-header-icon-button', className)} {...props}>
      <i className={iconClassName} aria-hidden="true"></i>
      {shouldShowBadge ? (
        <span className={joinClassNames('chat-header-icon-badge', badgeClassName)}>
          {formatBadgeCount(normalizedBadgeCount)}
        </span>
      ) : null}
    </button>
  );
};

export default ChatHeaderIconButton;
